<template>
	<div class="shop flex">
		<div style="flex-shrink: 0" class="mt-4">
			<img class="img" :src="row['product_pic']" alt="" />
		</div>
		<div class="ml-10 align-left shop-right yx-color-text-primary">
			<p class="flex flex-align-center" @click="jumpGoodsDetails(row)">
				<platform-icon style="min-width: 14px; margin-right: 4px" :platformId="row['platform_id']"></platform-icon>
				<rd-text class="pointer" :showCopy="true" :useByTable="false">{{ row['product_name'] }}</rd-text>
			</p>
			<rd-text>ID：{{ row['third_product_id'] }}</rd-text>
			<p class="yx-color-text-regular fz-12">
				<span class="team_pro mr-6" v-if="row['source_type'] === '2'">团长商品</span>
			</p>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	methods: {
		// 跳转到商品详情
		jumpGoodsDetails(row) {
			let handLink = this.$router.resolve({
				path: '/shopManage/shopLibrary/shopLibraryDetails',
				query: {
					productId: row.product_id,
					thirdProductId: row.third_product_id,
					platformId: row.platform_id,
				},
			});
			window.open(handLink.href, '_blank');
		},
	},
};
</script>
<style lang="less" scoped>
.img {
	width: 64px;
	height: 64px;
}
.shop-right {
	width: 220px;
}
.third-id {
	white-space: nowrap;
}
.team_pro {
	border-radius: 2px;
	padding: 2px 4px;
	text-align: center;
	width: 60px;
	background-color: #ebf2fd;
	color: @color-primary;
}
</style>
